import { InjectionToken } from '@angular/core';
import { CarpentryService } from '../services/configurators-2d/applications/carpentry.service';
import { CarpentryConfigurationComponent } from '../pages/configurators-2d/carpentry/configuration/configuration.component';
import { CarpentrySummaryComponent } from '../pages/configurators-2d/carpentry/summary/summary.component';
import { CarpentryAccessoriesComponent } from '../pages/configurators-2d/carpentry/accessories/accessories.component';

export const CA_CONFIGURATION = new InjectionToken(typeof CarpentryConfigurationComponent);
export const CA_ACCESSORIES = new InjectionToken(typeof CarpentryAccessoriesComponent);
export const CA_SUMMARY = new InjectionToken(typeof CarpentrySummaryComponent);
export const CA_SERVICE = new InjectionToken(typeof CarpentryService);
export const carpentryProviders = [
  {
    provide: CA_SERVICE,
    useClass: CarpentryService,
  },
  {
    provide: CA_CONFIGURATION,
    useClass: CarpentryConfigurationComponent,
  },
  {
    provide: CA_ACCESSORIES,
    useClass: CarpentryAccessoriesComponent,
  },
  {
    provide: CA_SUMMARY,
    useClass: CarpentrySummaryComponent,
  },
];
